import './style.scss';
import { useHistory } from 'react-router-dom';
import { LanguageType } from '../../../model';
import { LanguageType as langType } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';
import multiplayerIcon from '../../../assets/svg/document-multiplayer-icon.svg';
import socialIcon from '../../../assets/svg/document-social-icon.svg';
import economyIcon from '../../../assets/svg/document-economy-icon.svg';
import engageIcon from '../../../assets/svg/document-engage-icon.svg';
import contentIcon from '../../../assets/svg/document-content-icon.svg';
import analyticsIcon from '../../../assets/svg/document-analytics-icon.svg';
import { getDocumentParams } from '../utils';

interface IProps {
  readonly lang: LanguageType | null;
  readonly isDocPublicRoute: boolean;
}

export const ServicesManualContent = (props: IProps) => {
  const history = useHistory();
  const lang = props.lang === LanguageType.ZH ? langType.zh_CN : langType.en_US;
  const { projectId } = getDocumentParams();
  const servicesList = [
    {
      name: 'Multiplayer',
      icon: multiplayerIcon,
      color: '#F77E45',
      content: getFormatMessage('multiplayer_content', {}, lang),
      docId: {
        zh: '1026',
        en: '1110',
      },
    },
    {
      name: 'Social',
      icon: socialIcon,
      color: '#40D4CF',
      content: getFormatMessage('social_content', {}, lang),
      docId: {
        zh: '1027',
        en: '1111',
      },
    },
    {
      name: 'Economy',
      icon: economyIcon,
      color: '#165DFF',
      content: getFormatMessage('economy_content', {}, lang),
      docId: {
        zh: '1028',
        en: '1112',
      },
    },
    {
      name: 'Engagement',
      icon: engageIcon,
      color: '#F7BA1E',
      content: getFormatMessage('engage_content', {}, lang),
      docId: {
        zh: '1030',
        en: '1113',
      },
    },
    {
      name: 'Content',
      icon: contentIcon,
      color: '#722ED1',
      content: getFormatMessage('content_content', {}, lang),
      docId: {
        zh: '1029',
        en: '1234',
      },
    },
    {
      name: 'Analytics',
      icon: analyticsIcon,
      color: '#ED5C7F',
      content: getFormatMessage('analytics_content', {}, lang),
      docId: {
        zh: '1031',
        en: '1114',
      },
    },
  ];

  const joinPath = (
    projectId: string | number | undefined,
    docId?: string | number
  ) => {
    const url = props.isDocPublicRoute ? '/doc-public' : '/doc';
    if (!projectId) return;
    if (docId) {
      history.push(`${url}/detail/${projectId}/${docId}`);
      return;
    }
    history.push(`${url}/detail/${projectId}`);
  };

  return (
    <div className="services-manual-content">
      <div className="content-tips">
        {getFormatMessage('services_manual_tips', {}, lang)}
      </div>
      <div className="content-box">
        {servicesList.map((item) => {
          return (
            <div className="content-item">
              <div className="content-item-name-box">
                <img src={item.icon} className="content-item-icon" />
                <div
                  style={{ color: item.color }}
                  className="content-item-name"
                >
                  {item.name}
                </div>
              </div>
              <div className="content-item-content">{item.content}</div>
              <div
                className="content-item-btn"
                onClick={() =>
                  joinPath(
                    projectId,
                    lang === langType.zh_CN ? item.docId.zh : item.docId.en
                  )
                }
              >
                {getFormatMessage('services_item_btn', {}, lang)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
